import * as CeofenceActions from '../actions/ceofence.actions';

const INITIAL_STATE = {
  entities: {},
  ids: [],
  entitiesContract: {},
  idsContract: [],
  isLoading: false,
  loadingById: {},
  pathSuccess: null
};

export default function ceofence(state = INITIAL_STATE, action = '') {
  switch (action.type) {
    case CeofenceActions.LOAD:
    case CeofenceActions.LOAD_ONE:
    // case RequirementsActions.LOAD_CONTRACT:
    // case CeofenceActions.CREATE:
      return {
        ...state,
        isLoading: true
      };

    case CeofenceActions.LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: action.data.reduce((acc, item) => {
          acc[item.zon_id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.zon_id),
        pathSuccess: null
      };
    case CeofenceActions.LOAD_SUCCESS_ONE:
      return {
        ...state,
        isLoading: false,
        entities: action.data /* .reduce((acc, item) => {
          acc[item.id] = item;
          return acc;
        }, {}),
        ids: action.data.map((x) => x.id), */,
        pathSuccess: null
      };
    // case AlarmVelActions.LOAD_CONTRACT_SUCCESS:
    //   return {
    //     ...state,
    //     isLoading: false,
    //     entitiesContract: action.data.reduce((acc, item) => {
    //       acc[item.id] = item;
    //       return acc;
    //     }, {}),
    //     idsContract: action.data.map((x) => x.id),
    //     pathSuccess: null
    //   };
    case CeofenceActions.UPDATE_ONE:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.data.id]: true
        }
      };

    case CeofenceActions.UPDATE_ONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data
          }
        },
        loadingById: {
          ...state.loadingById,
          [action.data.id]: false
        }
        // pathSuccess: '/dashboard/forecast/list'
      };

    case CeofenceActions.UPDATE_ONE_FAILED:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.id]: false
        }
      };

    case CeofenceActions.CREATE_SUCCESS:
      // ids: action.users.map(x => x.id)
      return {
        ...state,
        entities: {
          ...state.entities,
          [action.data.id]: {
            ...state.entities[action.data.id],
            ...action.data
          }
        },
        ids: [...state.ids.filter((x) => x !== action.data.id), action.data.id],
        isLoading: false
        // pathSuccess: '/dashboard/forecast/list'
      };
    case CeofenceActions.CREATE_FAILED:
      return {
        ...state,
        isLoading: false
      };

    case CeofenceActions.DESTROY_SUCCESS:
      delete state.entities[action.id];
      // delete state.ids[action.id];

      return {
        ...state,
        entities: {
          ...state.entities
        },
        ids: state.ids.filter((id) => id !== action.id)
        /* ids: [
          ...state.ids
          // action.user.id
        ] */
      };
    case CeofenceActions.VOID:
      return {
        ...state,
        isLoading: false,
        entities: {},
        ids: [],
        group: {}
      };
    default:
      return state;
  }
}

export const getEntities = (state) => state.ceofence.entities;
export const getData = (state) => state.ceofence.ids.map((id) => state.ceofence.entities[id]);
export const getDataById = (state, id) => state.ceofence.entities[id];
export const getIsLoading = (state) => state.ceofence.isLoading;
// aths
export const getPath = (state) => state.ceofence.pathSuccess;
